import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import 'dayjs/locale/en'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/it'
import 'dayjs/locale/es'
import 'dayjs/locale/de'
import 'dayjs/locale/pt'
import 'dayjs/locale/ja'
import 'dayjs/locale/ko'
import dateFr from 'date-fns/locale/fr'
import dateEn from 'date-fns/locale/en-US'
import dateCn from 'date-fns/locale/zh-CN'
import dateIt from 'date-fns/locale/it'
import dateEs from 'date-fns/locale/es'
import dateDe from 'date-fns/locale/de'
import datePt from 'date-fns/locale/pt'
import dateJa from 'date-fns/locale/ja'
import dateKo from 'date-fns/locale/ko'
import { getStoredLang, DEFAULT_LANG } from '../utils/translations'

/**
 * Langue de l'interface = langue des données (sélecteur drapeaux, redux `settings.lang`).
 * Code admin (FR, EN, CN, …) -> code i18next / dossier `public/locales/<code>`.
 */
export const I18N_LANG_MAP = {
  FR: 'fr',
  EN: 'en',
  CN: 'cn',
  IT: 'it',
  ES: 'es',
  DE: 'de',
  PT: 'pt',
  JA: 'ja',
  KO: 'ko',
}

export const SUPPORTED_LNGS = Object.keys(I18N_LANG_MAP).map((code) => I18N_LANG_MAP[code])

const DAYJS_LOCALES = { fr: 'fr', en: 'en', cn: 'zh-cn', it: 'it', es: 'es', de: 'de', pt: 'pt', ja: 'ja', ko: 'ko' }
const DATE_FNS_LOCALES = { fr: dateFr, en: dateEn, cn: dateCn, it: dateIt, es: dateEs, de: dateDe, pt: datePt, ja: dateJa, ko: dateKo }

export function toI18nLang(code) {
  return I18N_LANG_MAP[code] || I18N_LANG_MAP[DEFAULT_LANG]
}

/** Aligne i18next (et dayjs) sur la langue des données. Appelé par `setLanguage` et à l'init. */
export function syncI18nLanguage(code) {
  const lng = toI18nLang(code)
  if (i18n.language !== lng) i18n.changeLanguage(lng)
}

/** Locale date-fns courante (formatRelative / format dans Cart et Confirm). */
export function getDateFnsLocale() {
  return DATE_FNS_LOCALES[i18n.language] || dateFr
}

i18n.on('languageChanged', (lng) => {
  dayjs.locale(DAYJS_LOCALES[lng] || 'fr')
})

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: toI18nLang(getStoredLang()),
    fallbackLng: 'fr',
    supportedLngs: SUPPORTED_LNGS,
    load: 'currentOnly',
    debug: false,
    interpolation: {
      // React échappe déjà les valeurs interpolées
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
